import App from './App'

// #ifndef VUE3
import Vue from 'vue'
import './uni.promisify.adaptor'
Vue.config.productionTip = false
Vue.prototype.$request = request
App.mpType = 'app'
const app = new Vue({
  ...App
})

app.$mount()
// #endif


// #ifdef VUE3
import { createSSRApp } from 'vue'
// 引入uviewPlus
import uviewPlus from '@/uni_modules/uview-plus'
// 引入全局store
import store from '@/store';
// 引入Vuex
import Vuex from "vuex";
// 引入mixin
import vuexStore from '@/store/$u.mixin.js'
// 引入自定义组件
import home from '@/pages/home/home.vue'
import shop from '@/pages/shop/shop.vue'
import dhShop from '@/pages/shop/dhShop.vue'
import cart from '@/pages/cart/cart.vue'
import mine from '@/pages/mine/mine.vue'
import jcOrderby from '@/components/jc-orderby/jc-orderby.vue'
import navbar from '@/components/navbar/navbar.vue'

/**
 * httpIns参数全局配置
 */
const initRequest = (http) => {
  http.setConfig((config) => {
    config.baseURL = import.meta.env.VITE_API_URL; /* 根域名 */
	config.header = {
      'content-type': 'application/x-www-form-urlencoded',
	  'RUID': store.getters.currentMembId
    }
    return config
  })
}

//引入过滤器
import * as filter from '@/common/filter.js'

export function createApp() {
  const app = createSSRApp(App)
  //引入uviewPlus
  app.use(uviewPlus, () => {
  	return {
  		httpIns: initRequest
  	}
  })
  // store
  app.use(store);
  // 使用mixin全局混入
  app.mixin(vuexStore) 
  // 引入组件
  app.component('home', home)
  app.component('shop', shop)
  app.component('dhShop', dhShop)
  app.component('cart', cart)
  app.component('mine', mine)
  app.component('jc-orderby', jcOrderby)
  app.component('navbar', navbar)
  //引入过滤器(Vue3.0已废弃过滤器，这里引入一些公共方法)
  app.config.globalProperties.$filter = filter;
  return {
    app,
	Vuex // 如果 nvue 使用 vuex 的各种map工具方法时，必须 return Vuex
  }
}

// #endif